import type { GetCommandsOptions, IProcessingStrategy } from '../interface-strategy'
import type {
  BatchCommandsArrayUniversal,
  BatchCommandsObjectUniversal,
  BatchCommandV3, ICallBatchResult
} from '../../../../../types/http'
import type { Result } from '../../../../result'
import type { AjaxError } from '../../../../http/ajax-error'
import { AbstractProcessingV3 } from './abstract-processing'
import { ParseRow } from '../../parse-row'

export class ProcessingAsArrayV3 extends AbstractProcessingV3 implements IProcessingStrategy {
  public prepareCommands(
    calls: BatchCommandsArrayUniversal | BatchCommandsObjectUniversal,
    options: GetCommandsOptions
  ): BatchCommandV3[] {
    const result: BatchCommandV3[] = []
    calls.forEach((row) => {
      const command = ParseRow.getBatchCommand(row, options)
      result.push(command)
    })

    return result
  }

  protected _processResponseError<T>(
    result: Result<ICallBatchResult<T>>,
    ajaxError: AjaxError,
    index: string
  ): void {
    // Key the error by the command's numeric position so getErrorsByKey() /
    // getErrorMessagesByKey() tell the caller *which* command failed, matching
    // object/named-command mode. (#255)
    result.addError(ajaxError, index)
  }
}
